<template>
    <MainContent :title="'Listado de ' + configuracion.simpatizantes">
        <template v-slot:header>
            <h3 class="card-title">Listado de {{ configuracion.simpatizantes }}</h3>
        </template>

        <template v-slot:subheader>
            <div class="row justify-content-between">
                <div class="col-4">
                    <SearchComponent v-model="filters.search" v-on:search="getAbonados"/>
                </div>
                <div class="col-4">
                    <div class="input-group input-group-sm">
                        <select class="custom-select" v-model="filters.tipo">
                            <option value="null">Seleccione una opción</option>
                            <option value="1">Procesado</option>
                            <option value="2">Validado</option>
                        </select>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:content>
            <div v-if="!loading">
                <b-table hover :items="abonados.data" :fields="fields" id="abonados-table">
                    <template #cell(id)="data">
                        <OpcionesDropdownComponent v-bind:options="[
                                            { to: { name: 'back.simpatizantes.show', params: { simpatizante_id: data.value}}, label: 'Ver'},
                                            { to: { name: 'back.simpatizantes.editar', params: { simpatizante_id: data.value}}, label: 'Editar'},
                                            { type: 'url', url: data.item.url_imprimir, label: 'Imprimir abono'},
                                            ... data.item.estado !== 2 ? [
                                                { type: 'action', action:() => validar(data.value), label: 'Validar'}
                                            ] : [],
                                        ]"/>
                    </template>
                </b-table>
                <hr>
                <div class="row justify-content-between">
                    <div class="col-3">
                        <ElementosPorPaginaComponent v-model="filters.per_page"/>
                    </div>
                    <div class="col-4" v-if="abonados">
                        <PaginateComponent :current_page="abonados.meta.current_page" :last_page="abonados.meta.last_page" v-on:change_page="setPage"></PaginateComponent>
                    </div>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
import MainContent from "../../../components/backend/components/MainContent";
import SearchComponent from "../../../components/backend/components/SearchComponent";
import ElementosPorPaginaComponent from "../../../components/backend/components/ElementosPorPaginaComponent";
import OpcionesDropdownComponent
from "../../../components/backend/components/OpcionesDropdownComponent";

export default {
    data() {
        return {
            abonados: null,
            loading: true,
            filters: {
                per_page: 10,
                page: 1,
                search: '',
                search_for: 'n_abonado',
                tipo: null
            },
            fields: [
                { key: 'n_pedido', label: 'Nº de abonado'},
                'nombre',
                'apellidos',
                'email',
                { key: 'estado_nombre', label: 'Estado'},
                { key: 'id', label: 'opciones', class: 'text-center' }
            ],
            debouncedgetAbonados: null
        }
    },
    created() {
        this.debouncedgetAbonados = _.debounce(this.getAbonados, 500);
        this.getAbonados();
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
    },
    methods: {
        validar(id) {
            this.loading = true;

            const params = {
                filters : {},
                simpatizante_id: id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.validar'), params).then(res => {
                this.$toast.success(res.data.message);
                this.getAbonados();
            }).finally(() => this.loading = false);
        },
        getAbonados : function() {
            this.loading = true;

            if(this.filters.tipo != 'null'){
                this.filters.filtro_estados = this.filters.tipo;
            }
            

            const params = {
                filters : this.filters
            };

            this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.index'), params).then(res => {
                this.abonados = res.data;
            }).finally(() => this.loading = false);
        },
        setPage(page) {
            this.filters.page = page;
            this.getAbonados();
        }
    },

    watch : {
        'filters.search'(){
            this.filters.page = 1;
            this.debouncedgetAbonados();
        },
        'filters.tipo'() {
            this.filters.page = 1;
            this.getAbonados();
        }
    },
    components: {
        OpcionesDropdownComponent, ElementosPorPaginaComponent, SearchComponent,
        MainContent, PaginateComponent
    }
}
</script>
